import './index.css'

import React from 'react'
import AmazonMusicSvg from 'assets/icons/amazon-music-logo.svg'
import ApplemusicSvg from 'assets/icons/apple-music-logo.svg'
import BandcampSvg from 'assets/icons/bandcamp-logo.svg'
import FacebookSvg from 'assets/icons/facebook-logo.svg'
import ImdbProSvg from 'assets/icons/imdb-pro-logo.svg'
import InstagramSvg from 'assets/icons/instagram-logo.svg'
import LinkSvg from 'assets/icons/link.svg'
import QobuzSvg from 'assets/icons/qobuz-logo.svg'
import SoundcloudSvg from 'assets/icons/soundcloud-logo.svg'
import SpotifySvg from 'assets/icons/spotify-logo.svg'
import TidalSvg from 'assets/icons/tidal-logo.svg'
import TiktokSvg from 'assets/icons/tiktok-logo.svg'
import TwitterSvg from 'assets/icons/twitter-logo.svg'
import WebsiteSvg from 'assets/icons/website-logo.svg'
import YoutubeSvg from 'assets/icons/youtube-logo.svg'
import Row from 'components/common/row'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import { PlaylistPresentationPrimaryCatalog } from './PlaylistPresentationPrimaryCatalog'
export const listLinks = [
  {
    value: 'social_links_aggregator',
    placeholder: 'Add link aggregator',
    getIcon: (className: string): React.ReactNode => (
      <LinkSvg className={className} />
    ),
  },
  {
    value: 'Instagram',
    placeholder: 'Instagram Link',
    getIcon: (className: string): React.ReactNode => (
      <InstagramSvg className={className} />
    ),
  },
  {
    value: 'Spotify',
    placeholder: 'Spotify artist URL',
    getIcon: (className: string): React.ReactNode => (
      <SpotifySvg className={className} />
    ),
  },
  {
    value: 'Apple Music',
    placeholder: 'Apple Music Link',
    getIcon: (className: string): React.ReactNode => (
      <ApplemusicSvg className={className} />
    ),
  },
  {
    value: 'Facebook',
    placeholder: 'Facebook Link',
    getIcon: (className: string): React.ReactNode => (
      <FacebookSvg className={className} />
    ),
  },
  {
    value: 'Twitter',
    placeholder: 'Twitter Link',
    getIcon: (className: string): React.ReactNode => (
      <TwitterSvg className={className} />
    ),
  },
  {
    value: 'Bandcamp',
    placeholder: 'Bandcamp Link',
    getIcon: (className: string): React.ReactNode => (
      <BandcampSvg className={className} />
    ),
  },
  {
    value: 'YouTube',
    placeholder: 'YouTube Link',
    getIcon: (className: string): React.ReactNode => (
      <YoutubeSvg className={className} />
    ),
  },
  {
    value: 'TikTok',
    placeholder: 'TikTok Link',
    getIcon: (className: string): React.ReactNode => (
      <TiktokSvg className={className} />
    ),
  },
  {
    value: 'SoundCloud',
    placeholder: 'SoundCloud Link',
    getIcon: (className: string): React.ReactNode => (
      <SoundcloudSvg className={className} />
    ),
  },
  {
    value: 'TIDAL',
    placeholder: 'TIDAL Link',
    getIcon: (className: string): React.ReactNode => (
      <TidalSvg className={className} />
    ),
  },
  {
    value: 'Website',
    placeholder: 'Website Link',
    getIcon: (className: string): React.ReactNode => (
      <WebsiteSvg className={className} />
    ),
  },
  {
    value: 'IMDb Pro',
    placeholder: 'IMDb Pro Link',
    getIcon: (className: string): React.ReactNode => (
      <ImdbProSvg className={className} />
    ),
  },
  {
    value: 'Qobuz',
    placeholder: 'Qobuz Link',
    getIcon: (className: string): React.ReactNode => (
      <QobuzSvg className={className} />
    ),
  },
  {
    value: 'Amazon Music',
    placeholder: 'Amazon Music Link',
    getIcon: (className: string): React.ReactNode => (
      <AmazonMusicSvg className={className} />
    ),
  },
]
type Props = {
  onClose: (...args: Array<any>) => any
  onSave: (...args: Array<any>) => any
  renderRow: (...args: Array<any>) => any
}

const PlaylistPresentationSocialLinks = ({
  onClose,
  onSave,
  renderRow,
}: Props): React.ReactNode => {
  return (
    <ModalWindow
      onClose={onClose}
      width="large"
      header={<Heading size={600}>Add social links</Heading>}
      isOpen
    >
      <div className="PlaylistPresentationSocialLinks_Row">
        <PlaylistPresentationPrimaryCatalog />
      </div>
      <Row columnsSize={[6, 6]}>
        <div>
          {listLinks.slice(0, Math.ceil(listLinks.length / 2)).map(renderRow)}
        </div>
        <div>
          {listLinks
            .slice(Math.ceil(listLinks.length / 2), listLinks.length)
            .map(renderRow)}
        </div>
      </Row>
      <ButtonContainer alignRight>
        <Button caption="Cancel" onClick={onClose} />
        <Button appearance="primary" caption="Save" onClick={onSave} />
      </ButtonContainer>
    </ModalWindow>
  )
}

export default PlaylistPresentationSocialLinks
